import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import './TrackCard.css';

const TrackCard = ({ track, onClick, isPlaying }) => {
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
    const cardRef = useRef(null);

    const handleMouseMove = (e) => {
        if (!cardRef.current) return;
        
        const rect = cardRef.current.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        
        const deltaX = (e.clientX - centerX) / (rect.width / 2);
        const deltaY = (e.clientY - centerY) / (rect.height / 2);
        
        setMousePosition({ x: deltaX, y: deltaY });
    };

    const handleMouseLeave = () => {
        setMousePosition({ x: 0, y: 0 });
    };

    const cardStyle = {
        transform: `
            perspective(1000px) 
            rotateY(${mousePosition.x * 15}deg) 
            rotateX(${-mousePosition.y * 15}deg) 
            translateZ(${Math.abs(mousePosition.x) * 20 + Math.abs(mousePosition.y) * 20}px)
        `,
        boxShadow: `
            ${mousePosition.x * 10}px 
            ${mousePosition.y * 10}px 
            ${20 + Math.abs(mousePosition.x) * 10}px 
            rgba(184, 148, 219, ${0.3 + Math.abs(mousePosition.x) * 0.2})
        `
    };

    return (
        <motion.div
            ref={cardRef}
            className={`track-card ${isPlaying ? 'playing' : ''}`}
            style={cardStyle}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            onClick={() => onClick(track)}
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            whileHover={{ y: -10 }}
            transition={{ duration: 0.3 }}
        >
            <div className="card-surface">
                <div 
                    className="track-cover" 
                    style={{ 
                        backgroundImage: `url(${track.cover || '/placeholder-cover.jpg'})` 
                    }}
                >
                    <div className="vinyl-reflection"></div>
                    <div className="vinyl-texture"></div>
                    
                    {isPlaying && (
                        <div className="playing-indicator">
                            <div className="sound-waves">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                    )}
                </div>
                
                <div className="track-info">
                    <div className="track-info-left">
                        <h3 className="track-title">{track.title}</h3>
                        <p className="track-artist">{track.artist}</p>
                    </div>
                    <div className="track-info-right">
                        <span className="track-duration">{track.duration}</span>
                        <div className="track-tags">
                            {track.genre && <span className="track-genre">{track.genre}</span>}
                            {track.tags && track.tags.slice(0, 2).map((tag, index) => (
                                <span key={index} className="track-tag">#{tag}</span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

export default TrackCard;